import React from "react";
import { PageFooterHyperlink } from "./page-footer-hyperlink";

export const PageFooter = () => {
  return (
    <footer className="page-footer">
      <div className="page-footer-grid__brand">
        <div className="page-footer-brand">
          <img
            className="page-footer-brand__logo"
            src="https://dopl-public-files.s3.us-west-2.amazonaws.com/dopl-logo-compliant-square.png"
            alt="Dopl Technologies Logo"
            width="20"
            height="22.22"
          />
          <PageFooterHyperlink path="https://dopltechnologies.com/">
            Dopl Technologies
          </PageFooterHyperlink>
        </div>
      </div>
    </footer>
  );
};
